import { normalizeInspection } from './inspection-helpers.js';

export function inspectionPhotos(raw) {
  const inspection = normalizeInspection(raw);
  const photos = [];
  function add(list, sectionKey, itemKey, label, note) {
    (Array.isArray(list) ? list : []).forEach((photo) => {
      if (!photo?.url) return;
      photos.push({
        key: JSON.stringify([sectionKey, itemKey, photo.id || photo.url]),
        sectionKey, itemKey, label, note: note || '', photo,
      });
    });
  }
  (inspection?.sections || []).forEach((section) => {
    if (section.kind === 'tires') {
      add(section.tires?.photos, section.key, null, section.label || 'Tires', section.tires?.note);
    } else {
      (section.items || []).forEach((item) => add(
        item.photos, section.key, item.key,
        `${section.label || 'Inspection'} · ${item.label || 'Item'}`, item.note,
      ));
    }
  });
  (inspection?.extraItems || []).forEach((item) => add(
    item.photos, null, item.key,
    `Additional recommendations · ${item.label || 'Item'}`, item.note,
  ));
  return photos;
}

export function replaceInspectionPhoto(raw, entry, replacement) {
  const inspection = normalizeInspection(raw);
  let replaced = false;
  function replace(list) {
    return (list || []).map((photo) => {
      if (photo.id !== entry.photo.id || photo.url !== entry.photo.url) return photo;
      replaced = true;
      // Keep its identity so the viewer stays on the retaken photo.
      return { ...replacement, id: photo.id || replacement.id };
    });
  }
  const next = {
    ...inspection,
    archivedPhotoPaths: [...new Set([
      ...(inspection?.archivedPhotoPaths || []),
      ...(entry.photo.path ? [entry.photo.path] : []),
    ])],
    sections: (inspection?.sections || []).map((section) => {
      if (section.key !== entry.sectionKey) return section;
      if (section.kind === 'tires') {
        return { ...section, tires: { ...section.tires, photos: replace(section.tires?.photos) } };
      }
      return { ...section, items: (section.items || []).map((item) => (
        item.key === entry.itemKey ? { ...item, photos: replace(item.photos) } : item
      )) };
    }),
    extraItems: (inspection?.extraItems || []).map((item) => (
      entry.sectionKey === null && item.key === entry.itemKey
        ? { ...item, photos: replace(item.photos) } : item
    )),
  };
  if (!replaced) throw new Error('This photo has changed. Close the viewer and reopen it before replacing it.');
  return next;
}
